import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { TrainingsCatalogPageDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useQuery } from 'modules/core/hooks/useQuery'

import PageLoading from 'modules/layout/components/Page/Loading'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { CatalogDatatable } from 'modules/trainings/components/CatalogComponent/CatalogDatatable'
import { EmptyStateAdmin } from 'modules/trainings/components/CatalogComponent/EmptyStateAdmin'

const Catalog = () => {
  const { loading, data } = useQuery(TrainingsCatalogPageDocument)
  const categories = data ? data.trainings.categories : undefined
  const competencies = data ? data.competencies.competenciesConnection.nodes : undefined

  if (loading) {
    return (
      <Box width="full" height="full" justifyContent="center">
        <ResponsivePage.Body variant="wide" showHeader={false}>
          <PageLoading />
        </ResponsivePage.Body>
      </Box>
    )
  }

  if (
    (!data?.trainings._policies.trainingsSeeCatalog.can ||
      !data?.trainings._policies.trainingsRequestsCreate.can) &&
    !data?.trainings._policies.trainingsAccessManagementSpace.can
  )
    return <NotFound />

  const isEmpty = data.trainings.trainingsConnection.totalCount === 0
  const accessManagementSpace = data?.trainings._policies.trainingsAccessManagementSpace.can
  return (
    <ResponsivePage.Body variant="full" showHeader={!isEmpty}>
      {isEmpty && accessManagementSpace && <EmptyStateAdmin />}
      {(!isEmpty || !accessManagementSpace) && (
        <Box flexGrow width="full">
          <Box gap="s8">
            <CatalogDatatable categories={categories} competencies={competencies} />
            <Outlet />
          </Box>
        </Box>
      )}
    </ResponsivePage.Body>
  )
}

export default Catalog
